var nibInkOptions = null,
    adhSidesOptions = null,
    txtTimer = null,
    imageURL = $('#img0').find('img').attr('src'),
    recolorURL = '//cdna.4imprint.com/prod/rend/',
    glide;

    var currencySymbol = $('#currencySymbol').text();

$(function() {
    CheckQueryString();

    function CheckQueryString() {
        var qryStr = window.location.search;
        qryStr = qryStr.indexOf("gfeed=1");
        if (qryStr > 0) {
            $('.PLA_SelectionBox').removeClass('hide');
            SetupGlide();
            $("#GlideSlider").sliderglide("value", 100);
        }
    }

    var width = $(window).width();
    var MaximumImprintColors = $('#MaximumImprintColors').val();
    var jsonExtras = '';

    $('#trimSpan').removeClass('hide');
    $('#baseSpan').removeClass('hide');
    
    if ($('#editItem').val() != 'true') {
        $('.sizeSelectionTbl').each(function (i) {
         if (i > 0 && $(this).attr('id') != 'closedItemRow' && $.trim($('#SelectionQtyTotal').html()).length < 1) { $(this).hide(); }
            $('tr').each(function (i) {
                if ($(this).attr('class') == 'unavailableRow') { $(this).hide(); }
            });
        });
    } else {
        $('.sizeSelectionTbl tr').each(function (i) {
             if ($(this).attr('id') == 'closedItemRow') { $(this).hide(); }
             if ($(this).attr('class') == 'unavailableRow') { $(this).hide(); }
        });
    }

    $('#mainContent').numeric().on('keyup', 'input.qty', function (e) {
        calcPrice();
    });
    
    var allCartPanelsButFirst = $('.cartAccordion > li:not(:first-child) > .pnlContent').hide();

    $('#cartPanel').on('click touch', '.cartAccordion li .panelHeading', function() {
        var allCartPanels = $('.cartAccordion > li > .pnlContent');
        var allCartBoxes = $('.cartAccordion > .pnlBox');
        $this = $(this);
        $target = $this.next();

        if (!$target.hasClass('active')) {
            allCartPanels.removeClass('active').slideUp();
            allCartBoxes.removeClass('activeBlue');
            $target.addClass('active').slideDown();
            $target.parent('.pnlBox').addClass('activeBlue');
        } else {
            $target.removeClass('active').slideUp();
            $target.parent('.pnlBox').removeClass('activeBlue');
        }

        return false;
    });

    $('.flexslider').flexslider({
        selector: '.slides > .colorGroup',
        animation: 'slide',
        animationLoop: false,
        slideshow: false,
        speed: 700,

        //carousel options
        itemWidth: 60,
        itemMargin: 15,
        minItems: 1,
        maxItems: 100,
        move: 0,

        mousewheel: true,
        controlNav: false,
        directionNav: false,
        prevText: "",
        nextText: "",
        slideshow: false,
        controlsContainer: "",
        manualControls: "",
        sync: "",
        asNavFor: ""
    });

     // check the first checkbox initially for imprint color & location : only on non edit
    if ($('#editItem').val() != 'true') {
        if ($('#chkLocation_0')) {
            $('#chkLocation_0').attr('checked', true);
            $('#PossibleImprintLocations').val('chkLocation_0');
        }
    } else {
        // calculate price on apparel edit items
        calcPrice();
        // add extras
        AddExtras($('#productid').val(), $('#selectedColor').attr('data-base'), $('#selectedColor').attr('data-trim'));
    }

    // there's only one item color so automatically select it
    if ($('#selectedColor').hasClass('oneColorOption')) {
        $('#ItemColor').html($('.oneColorOption').attr('data-color'));
        $('#hdItemColor').addClass('GoAhead');
        //build sizing chart if apparel
        if ($('#ApparelProduct').val() == 'True') {
            BuildSizingChartForSingleItem($('#productid').val(), $('.oneColorOption').attr('data-base'), $('.oneColorOption').attr('data-trim'));
        }

    }

    // there's only one imprint color
    if ($('#inputImpLoc_0').val() != "" && $('#editItem').val() != 'true') {
        $('#hdImprint').addClass('GoAhead');
        //$('#chkLocation_0').attr('onclick', '');
        AddToCartCriteriaMet();
    }

    // Glide settings
    $("#txtQty").on("keypress", function(e) {
        if ((e.which && e.which == 13) || (e.keyCode && e.keyCode == 13)) {
            TextUpdateSliderFinish($(this).val());
        }
    });

    $("#txtQty").on("keyup", function(e) {
        TextUpdateSlider($(this).val());
        $("#ItemQuantity").val($('#txtQty').val());
    });

    // extras radio button change
    $('body').on('click', '.extraRadio input[type="radio"]', function() {
        nibInkOptionChanged();
    });

    SetupGlide();
	
   // $("#ItemQuantity").val($('#txtQty').val());

    $("body").on("click", ".showMoreReviews", function(e) {
        e.preventDefault();

        $("#ajaxDiv").block({
            message: "<img src='//cdna.4imprint.ie/qtz/core/loadingcircle2016.gif' alt=''/>",
            overlayCSS: {
                backgroundColor: "#fff",
                opacity: 1,
                cursor: "default"
            }
        });
        $.ajax({
            type: "POST",
            url: "/ProductMobile/CustomerReviewsPaged",
            dataType: "html",
            data: {
                reportSKU: $("#reportSKU").val(),
                page: $(this).attr("href"),
                rating: rating
            },
            timeout: 0,
            success: function(n) {
                $(".showMoreReviews").remove();
                $("#productReviews").append(n);
                $("#ajaxDiv").unblock()
            },
            error: function(n) {
                alert(e.responseText);
                $("#ajaxDiv").unblock()
            }
        })
    });
/**
//This does not appear to be used on the mobile site currently. .sortbyrating is in _reviewCart.cshtml, but nothing uses that partial view.
    $("body").on("click", ".sortbyrating", function(e) {
        e.preventDefault();
        var el = $(this);
        el.parent().block({
            message: "<img src='//cdna.4imprint.ie/qtz/core/loadingcircle2016.gif' alt=''/>",
            overlayCSS: {
                backgroundColor: '#fff',
                opacity: 1.0,
                cursor: 'default'
            }
        });
        $.ajax({
            type: "POST",
            url: "/ProductMobile/CustomerReviewsPaged",
            data: {
                reportSKU: $("#reportSKU").val(),
                page: 1,
                rating: $(this).attr("href")
            },
            dataType: "html",
            timeout: 0,
            success: function(result) {
                el.parent().unblock();
                $("#productReviews").html(result);
                $("html, body").animate({
                    scrollTop: ($("#productReviews").offset().top)
                }, 500);
            },
            error: function(error) {
                el.parent().unblock();
                alert(error.responseText);
            }
        });
    });
**/

    //Begin the move from Mobile/js/Sop.js
    // MISSING FIELDS - DON'T ADD TO CART YET
    $('body').on('click', '.notReadyForCartBtn', function (e) {
        // display the first panel that isn't ready to go
        var firstPanelRequiringInformation = $('.cartAccordion > li.pnlBox > div:not(".GoAhead"):first').trigger('click');
        setTimeout(function () {
            alert('Please make sure all fields are filled in.');
        }, 1000);
    });    

    // ADD TO CART
    $('body').on('click', '.addToCartBtn', function (e) {
        var theQuantity = '';
        // get apparel quantity or get glide quantity
        if ($('#ApparelProduct').val() == 'True') {
            setQuantity()
            theQuantity = $('#SizeSelections').val();
        } else {
            theQuantity = $("#ItemQuantity").val();
        }

        // get imprint index
        var arrImprintIndex = new Array();
        arrImprintIndex = $('#PossibleImprintLocations').val().split(',');

        // get imprint location id
        var jsonString = '[';
        for (var i = 0; i < arrImprintIndex.length; i++) {
            var chkIndex = arrImprintIndex[i].substring(arrImprintIndex[i].length - 1);

            jsonString += '{';
            jsonString += '"imprintlocationID":"' + $('#inputImpLocIDs_' + chkIndex).val() + '",';
            jsonString += '"imprintcolorIDs":"' + $('#inputImpLoc_' + chkIndex).val() + '",';
            jsonString += '"imprintExclusive":"' + $('#inputIsExcl_' + chkIndex).val() + '"';
            jsonString += '},';
        }
        jsonString = jsonString.slice(0, -1);
        jsonString += ']';

        // get extras information
        var extrainfo = $('#selectedExtraID').val();

        $.ajax({
            url: '/Cart/AddToCart',
            type: 'POST',
            dataType: 'json',
            data: {
                prodid: $("#productid").val(),
                quantity: theQuantity,
                baseid: $("#selectedColor").attr('data-base'),
                trimid: $('#selectedColor').attr('data-trim'),
                imprintinfo: jsonString,
                extrainfo: extrainfo,
                hassizing: $('#ApparelProduct').val()
            },
            success: function (result) {
                window.location.assign(result.url);
            },
            error: function (xhr, status, error) {
                alert('Please make sure all fields are filled in.');//TODO add much better error validation, handling and messages
            }
        });
    });
    //End ADD TO CART

    // UPDATE CART ITEM
    $('.updateCartBtn').on('click', function (e) {
        var theQuantity = '';
        // get apparel quantity or get glide quantity
        var canUpdate = true;
        if ($('#ApparelProduct').val() == 'True') {
            canUpdate = setQuantityWhenUpdating();
            theQuantity = $('#SizeSelections').val();
        } else {
            theQuantity = $("#ItemQuantity").val();
        }

        // get imprint index
        var arrImprintIndex = new Array();
        arrImprintIndex = $('#PossibleImprintLocations').val().split(',');

        // get imprint location id
        var jsonString = '[';
        for (var i = 0; i < arrImprintIndex.length; i++) {
            var chkIndex = arrImprintIndex[i].substring(arrImprintIndex[i].length - 1);

            jsonString += '{';
            jsonString += '"imprintlocationID":"' + $('#inputImpLocIDs_' + chkIndex).val() + '",';
            jsonString += '"imprintcolorIDs":"' + $('#inputImpLoc_' + chkIndex).val() + '",';
            jsonString += '"imprintExclusive":"' + $('#inputIsExcl_' + chkIndex).val() + '"';
            jsonString += '},';
        }
        jsonString = jsonString.slice(0, -1);
        jsonString += ']';

        // get extras information
        var extrainfo = $('#selectedExtraID').val();
	if (canUpdate){
        $.ajax({
            url: '/Cart/UpdateCart',
            type: 'POST',
            dataType: 'json',
            data: {
                itemid: $('.updateCartBtn').attr('data-itemid'),
                prodid: $("#productid").val(),
                quantity: theQuantity,
                baseid: $("#selectedColor").attr('data-base'),
                trimid: $('#selectedColor').attr('data-trim'),
                imprintinfo: jsonString,
                extrainfo: extrainfo,
                hassizing: $('#ApparelProduct').val()
            },
            success: function (result) {
                window.location.assign(result.url);
            },
            error: function (xhr, status, error) {
                alert('error');
            }
        });
        }
    });
    //End UPDATE CART ITEM

    // ADD TO WISHLIST
    $("#addToWishlistBtn").on("click", function (e) {
    	  metricsLogWishlistClick("Add to Wishlist");
        var data = { productID: $("#productid").val() };
        $.ajax({
            type: "POST",
            url: "/Cart/AddToWishlist",
            dataType: 'json',
            data: data,
            success: function (result) {
                window.location.assign(result.url);
            },
            error: function (xhr, status, error) {
                alert($("#productid").val() + ' ' + error.responseText);
            }
        });
    });
   //End move from Mobile/js/Sop.js
});

function BuildSizingChartForSingleItem(productID, baseID, trimID) {
    if (baseID != "-1" && trimID != "-1") {
        $.post("/ProductMobile/BuildSizingChart", {
            productid: productID,
            baseid: baseID,
            trimid: trimID,
            EditID: 0
        }, function(data) {
            $("#UpdateableContent").html(data);
        });
        $('#txtQty').html('');
        $('#SelectedQtyPrice').html('');
        $('#SelectedQtyTotal').html('');
    }
}

function ToggleImpLocation(chkClicked, IsExclusive) {
    resetCalcExtras();
    var chkBox = $('#' + chkClicked);
    var index = chkClicked.substr(chkClicked.length - 1);
    var ImpLocs = $('#' + possibleImprintLocs);
    var IsExcl = $('#' + IsExclusive);
    var arrImpLocs = new Array();
    if (ImpLocs.val().length > 0) {
        if (ImpLocs.val().lastIndexOf(',') > -1) {
            arrImpLocs = ImpLocs.val().split(',');
        } else {
            arrImpLocs.push(ImpLocs.val());
        }
    }
    if (chkBox.is(':checked') == true) {
        // check that there are no exclusive locations selected with other items!
        if (arrImpLocs.length > 0) {
            // if the one selected is Exlusive, uncheck all the others. 
            if (IsExcl.val() == 'True') {
                // uncheck all the checked ones - this guy is exclusive. 
                for (var i = 0; i < arrImpLocs.length; i++) {
                    var currentIndex = arrImpLocs[i].substr(arrImpLocs[i].length - 1);
                    $('#' + arrImpLocs[i]).removeAttr('checked');
                    RemoveAllImprintColors('inputImpLoc_' + currentIndex, currentIndex);
                    $('#' + arrImpLocs[i]).parent().siblings(".PD_ImprintLocationPanel").slideToggle();
                }
                arrImpLocs.length = 0;

            } else {
                // make sure an exclusive one isn't already checked. if so, uncheck it
                for (var i = 0; i < arrImpLocs.length; i++) {
                    var ParentPath = arrImpLocs[i].substr(arrImpLocs[i].length - 1);
                    var ExistingExclusive = 'inputIsExcl_' + ParentPath;
                    if ($('#' + ExistingExclusive).val() == 'True') {
                        // uncheck
                        $('#' + arrImpLocs[i]).removeAttr('checked');

                        // remove colors
                        RemoveAllImprintColors('inputImpLoc_' + i, i);

                        // close that check area
                        $('#' + arrImpLocs[i]).parent().siblings(".PD_ImprintLocationPanel").slideToggle();

                        // finally, remove the chkLocation from #PossibleImprintLocations
                        var arrNewLocs = new Array();
                        for (var x = 0; x < arrImpLocs.length; x++) {
                            if (arrImpLocs[x] != arrImpLocs[i]) {
                                arrNewLocs.push(arrImpLocs[x]);
                            }
                        }
                        arrImpLocs = arrNewLocs;
                    }
                }
            }
        }
        arrImpLocs.push(chkClicked);
        ImpLocs.val(arrImpLocs.join(','));
    } else {
        var arrNewLocs = new Array();
        for (var i = 0; i < arrImpLocs.length; i++) {
            if (arrImpLocs[i] != chkClicked) {
                arrNewLocs.push(arrImpLocs[i]);
            }
        }

        if (arrNewLocs.length == 0) {
            ImpLocs.val("");
        } else {
            ImpLocs.val(arrNewLocs.join(','));
        }

        // clear the colors if any were selected also...
        var hiddenInput = 'inputImpLoc_' + index;
        RemoveAllImprintColors(hiddenInput, index);
    }

    if ($(".PD_ImprintBox input:checkbox:checked").length > 0) {
        // any one is checked
        if($('#inputImpNoOrOneColor_' + index).length && $('#inputImpNoOrOneColor_' + index).val() == 'true' && $('#chkLocation_' + index + ':checkbox:checked').length > 0)
       { 
       	$('#hdImprint').addClass('GoAhead');
       	AddToCartCriteriaMet();
       }
    } else {
        // none are checked
        $('#hdImprint').removeClass('GoAhead');
        AddToCartCriteriaMet();
    }

    chkBox.parent().siblings(".PD_ImprintLocationPanel").slideToggle();
}

function resetCalcExtras() {
    $('.extrasLoadingImg').hide();
    $('#extrasResult').slideUp('fast', function() {
        $('.calcExtrasBtn').fadeIn();
    });
    $('#selectedExtras').slideUp('fast');
}

function SaveImprintColor(hiddenInput, colorID, hex, parentID, divNeedMoreColors, MaxImprintColors, ColorName) {
    ImprintColorInput = $('#' + hiddenInput);
    var MoreColorsLabel = $('#' + divNeedMoreColors);
    if (MaxImprintColors > 1) {
        if (MoreColorsLabel.css('display') == 'none') {
            if (ImprintColorInput.val().length > 0) {
                var arrTempImpColors = ImprintColorInput.val().split('|');
                if (ImprintColorInput.val().substr(-1) == "|") {
                    arrTempImpColors.pop();
                    ImprintColorInput.val(ImprintColorInput.val().substring(0, ImprintColorInput.val().length - 1));
                }

                if ($('#' + parentID + ' #spnImpColor_1').css('display', 'inline')) {
                    if (arrTempImpColors.length < MaxImprintColors) {
                        ImprintColorInput.val(ImprintColorInput.val() + "|" + colorID + "|");
                    } else {
                        // the last imprint color option has been reached, so change the last value to the new color
                        arrTempImpColors.pop();
                        arrTempImpColors.push(colorID);
                        ImprintColorInput.val(arrTempImpColors.join('|') + "|");
                    }
                    MoreColorsLabel.addClass('hide');
                } else {
                    ImprintColorInput.val(colorID + "|");
                    MoreColorsLabel.css("visibility", "visible");
                }
            } else {
                ImprintColorInput.val(colorID + "|");
                MoreColorsLabel.css("visibility", "visible");
            }
        } else {
            ImprintColorInput.val(colorID + "|");
            MoreColorsLabel.css("visibility", "visible");
        }
    } else {
        ImprintColorInput.val(colorID + "|");
    }
    var arrImprintCols = ImprintColorInput.val().split('|');
    arrImprintCols.pop();

    var boxToColor = $('#' + parentID + ' #spnImpColor_' + ((arrImprintCols.length > 0) ? arrImprintCols.length - 1 : arrImprintCols.length));
    var boxToName = $('#' + parentID + ' #spnImpColorName_' + ((arrImprintCols.length > 0) ? arrImprintCols.length - 1 : arrImprintCols.length));
    if ($('#' + parentID + ' #spnImpColor_' + arrImprintCols.length)) {
        $('#' + parentID + ' #spnImpColor_' + arrImprintCols.length).addClass("PD_ImprintColorChoiceBox_On");
        boxToColor.removeClass('PD_ImprintColorChoiceBox_On');
    }
    boxToColor.css('background-color', hex);
    //boxToName.html(ColorName);

    $('#hdImprint').addClass('GoAhead');

    AddToCartCriteriaMet();
}

function UnlockMoreColors(divNeedMoreColors, parentID, MaxImprintColors) {
    /// <summary>Called after clicking the more colors button, this displays the boxes after the first for additional color entries</summary>
    /// <param name="divNeedMoreColors">Div containing the more colors button</param>
    /// <param name="MaxImprintColors">Maximum number of imprint colors</param>

    for (var i = 1; i < MaxImprintColors; i++) {
        if ($('#' + parentID)) {
            $('#' + parentID + ' #selectedColorLine_' + i).css('display', 'block');
        }
    }
    $('#' + divNeedMoreColors).addClass('hide');
}

function DeleteImprintColor(hiddenInput, parentID, indexToDelete) { //old...
    ImprintColorInput = $('#' + hiddenInput);
    if (ImprintColorInput.val().endsWith("|")) {
        ImprintColorInput.val(ImprintColorInput.val().substring(0, ImprintColorInput.val().length - 1));
    }

    if (ImprintColorInput.val().length > 0) {
        var arrColors = ImprintColorInput.val().split('|');
        if (indexToDelete < arrColors.length) {
            var arrNewColors = new Array();
            var counter = 0;

            if ($('#' + parentID + ' #spnImpColor_' + arrColors.length).length > 0) {
                $('#' + parentID + ' #spnImpColor_' + arrColors.length).removeClass("PD_ImprintColorChoiceBox_On");
                $('#' + parentID + ' #spnImpColor_' + (arrColors.length - 1)).addClass("PD_ImprintColorChoiceBox_On");
            }

            for (var i = 0; i < arrColors.length;) {
                if (counter >= indexToDelete) {
                    // Change the background color to the value of the next item
                    if ($('#' + (parentID + ' #spnImpColor_' + (counter + 1))).length > 0) {
                        $('#' + (parentID + ' #spnImpColor_' + counter)).css('background-color', $('#' + (parentID + ' #spnImpColor_' + (counter + 1))).css('background-color'));
                        $('#' + (parentID + ' #spnImpColorName_' + counter)).html($('#' + (parentID + ' #spnImpColorName_' + (counter + 1))).html());
                    } else {
                        $('#' + (parentID + ' #spnImpColor_' + counter)).css('background-color', "White");
                        $('#' + (parentID + ' #spnImpColorName_' + counter)).html('');
                    }
                }
                if (counter != indexToDelete) {
                    arrNewColors.push(arrColors.shift());
                } else {
                    arrColors.shift();
                }
                counter++;
            }

            ImprintColorInput.val(arrNewColors.join('|'));
        }
    }
}

function RemoveAllImprintColors(hiddenInput, index) {
	//the imprint colors should only be removed if the NoOrOneColor exists and the value is not true
    if(!($('#inputImpNoOrOneColor_' + index).length && $('#inputImpNoOrOneColor_' + index).val() == 'true')){
	    ImprintColorInput = $('#' + hiddenInput);
	    if (ImprintColorInput.val().endsWith("|")) {
	        ImprintColorInput.val(ImprintColorInput.val().substring(0, ImprintColorInput.val().length - 1));
	    }
	
	    if (ImprintColorInput.val().length > 0) {
	        var arrColors = ImprintColorInput.val().split('|');
	
	        for (var i = 0; i < arrColors.length + 1; i++) {
	            var currentSelectionBox = $('#rptImprintCols' + index + ' #spnImpColor_' + i);
	            currentSelectionBox.css('background-color', 'White');
	            if (i == 0) {
	                currentSelectionBox.addClass("PD_ImprintColorChoiceBox_On");
	            } else {
	                currentSelectionBox.removeClass("PD_ImprintColorChoiceBox_On");
	            }
	        }
	
	        if ($('#rptImprintCols' + index + ' #spnImpColor_' + arrColors.length)) {
	            $('#rptImprintCols' + index + ' #spnImpColor_' + arrColors.length).addClass("PD_ImprintColorChoiceBox");
	        }
	    }
	    $('.PD_ImprintColorName').html('');
	    ImprintColorInput.val("");
    }
}

// apparel - sizing chart calculations
function calcPrice() {
    var TotalQty = 0;
    $('.sizeSelectionTbl .qty').each(function() {
        if ($(this).val().length > 0) {
            TotalQty += parseInt($(this).val());
        };
    });
    $('#' + quantityTextbox).html(TotalQty);
    if (TotalQty >= lowestQty) {
        var BreakNumBelow = -1;
        var BreakNumAbove = -1;
        for (var i = 0; i < arrBreak.length; i++) {
            if ((i + 1 >= arrBreak.length || arrBreak[i + 1] < 1) && TotalQty >= arrBreak[i] && arrBreak[i] > 0) {
                BreakNumBelow = i;
                BreakNumAbove = i;
            } else {
                if (TotalQty >= arrBreak[i] && TotalQty < arrBreak[i + 1]) {
                    BreakNumBelow = i;
                    BreakNumAbove = i + 1;
                }
            }
        }

        SetupGlide();
        var newPrice = glide.GetPriceEstimate(BreakNumBelow, TotalQty, 0);
        $('#' + priceLabel).html(currencySymbol + newPrice.toFixed(2).toString());
        $('#' + totalLabel).html(currencySymbol + (newPrice * TotalQty).toFixed(2).toString());
        $('#hdQuantity').addClass('GoAhead');
        AddToCartCriteriaMet();
    } else {
        $('#' + priceLabel).html('');
        $('#' + totalLabel).html('');
        $('#hdQuantity').removeClass('GoAhead');
        AddToCartCriteriaMet();
    }
}

function SetSlider(qty) {
    var prevValue = $("#GlideSlider").sliderglide("value");
    $("#GlideSlider").sliderglide("value", glide.SetSlideQty(qty));
}

function SetupGlide() {
    if (Glide4imprint) {
        glide = new Glide4imprint();
        glide.Init(arrBreak, arrPrice, steppingQty);

        if ($.slider) {
            $("#GlideSlider").sliderglide({
                from: glide.MinPoint(),
                to: glide.MaxPoint(),
                step: 1,
                smooth: true,
                scale: [glide.MinBreakQty(), glide.MaxBreakQty()],
                limits: false,
                dimension: '', // Needed for the hint bubble above slider
                valueOffset: 18, // Custom added property, offsets the value bubble to the right (value is in px)
                calculate: function(value) {
                    UpdatePrice(value.toString());
                    return $('#' + quantityTextbox).val(); // Need to return the quantity for the hint bubble to display it
                },
                callback: function(value) {
                    $("#ItemQuantity").val($('#' + quantityTextbox).val());
                }
            });

            // If editing update the slider with the appropriate qty
            if (EditQty > 0) {
                TextUpdateSliderFinish(EditQty);
            }
        }
    }
}

function UpdatePrice(qty) {
    var firstDigit = glide.GetBreakSegment(qty);
    var quantity = glide.GetSlideQty(firstDigit, qty);
    if (lowestQty <= quantity) {
        if (firstDigit != null) {
            var newPrice = glide.GetPriceEstimate(firstDigit, quantity, qty);
            var startPrice = arrPrice[1]; // pricing always starts at index 1
            $('#' + priceLabel).val(currencySymbol + newPrice.toFixed(2).toString());
            $('#' + totalLabel).html(currencySymbol + (newPrice * quantity).toFixed(2).toString());
            $('#' + quantityTextbox).val(quantity);
            if (newPrice.toFixed(2) >= startPrice.toFixed(2)) {
                if ($('div#YouSaveBox').css('visibility') == 'visible') {
                    $('div#YouSaveBox').css('visibility', 'hidden');
                }
            } else {
                if ($('div#YouSaveBox').css('visibility') == 'hidden') {
                    $('div#YouSaveBox').css('visibility', 'visible');
                }
                $('div#divYouSave').html(currencySymbol + ((startPrice * quantity) - (newPrice * quantity)).toFixed(2).toString());
            }
        }
    }
    $('#hdQuantity').addClass('GoAhead');
    AddToCartCriteriaMet();
}

function TextUpdateSlider(qty) {
    //if (txtTimer != null) {
    //    clearTimeout(txtTimer);
    //}
    $("#ItemQuantity").val($('#txtQty').val());
    txtTimer = setTimeout("TextUpdateSliderFinish('" + qty + "')", 500);
}

function TextUpdateSliderFinish(qty) {
    if (IsNumeric(qty)) {
        qty = parseInt(qty);

        var SlideQty = qty;
        if (parseInt(lowestQty) <= qty) {
            for (var i = arrBreak.length - 1; i > 0; i--) {
                if (arrBreak[i] > 0) {
                    // If the qty is greater than the end of the slider, need to set the value to slide to the last break.
                    if (qty > arrBreak[i]) {
                        SlideQty = arrBreak[i];
                        qty = enforceSteppingQty(qty, steppingQty);
                    }
                    break;
                }
            }

            // Only update the slider if there are multiple qty breaks
            if (arrBreak[2] > 0) {
                SetSlider(SlideQty);
            }

            // The slider doesn't deal in qtys, just percentages, so sometimes it will adjust the qty when it does
            // its percentage calculation if the user typed a qty. This will reset it to the user entered value.
            var qtyTxtbox = $('#' + quantityTextbox);
            if (qty > SlideQty) {
                qtyTxtbox.val(qty);
                var price = parseFloat($('#' + priceLabel).val().substring(1)); // Trims the currency symbol
                $('#' + totalLabel).html(currencySymbol + (price * qty).toFixed(2).toString());
                $('.jslider-value span').first().html(qty);
            } else {
                if (parseInt(qtyTxtbox.val()) != qty) {
                    if (enforceSteppingQty(qty, steppingQty) == qty) {
                        qtyTxtbox.val(qty);
                        var price = parseFloat($('#' + priceLabel).val().substring(1)); // Trims the currency symbol
                        $('#' + totalLabel).html(currencySymbol + (price * qty).toFixed(2).toString());
                        $('.jslider-value span').first().html(qty);
                    }
                }
            }
        } else {
            $('#hdQuantity').removeClass('GoAhead');
            AddToCartCriteriaMet();
        }
    }
}

function SetBaseTrim(productID, baseColor, trimColor, baseName, trimName, renderBaseOnly, baseID, trimID, recolor) {

    if (recolor == 'true') {
        var recoloredImage = recolorURL + '250/' + productID + '/' + baseID + '_' + trimID + '.jpg';
        var source = $('#img0').find('img').attr('src', recoloredImage);
        var zoomUrl = recolorURL + '700/' + productID + '/' + baseID + '_' + trimID + '.jpg';
        var zoomsource = "zoomInImg('" + zoomUrl + "')";
        $('#main_zoom_in_icon').attr('onclick', zoomsource);
       var zattr = $('#photoZoomBox img').attr('src');
		if (typeof zattr !== typeof undefined && zattr !== false) {
		    if ($('#photoZoomBox img').attr('src').indexOf('extras') == -1)
		        	$('#photoZoomBox img').attr('src', zoomUrl);
		}
    }
    nibInkOptions = null;

    AddExtras(productID, baseID, trimID);

    var baseDisplay = $('#baseSpan');
    var trimDisplay = $('#trimSpan');
    var selectedColors = $('.selColors');

    if (baseColor != "#" && trimColor != "#") {
        // change background color of Selected Color Boxes
        baseDisplay.css('background-color', baseColor);
        trimDisplay.css('background-color', trimColor);
	  
	  
        // display Selected Color Names
        if (baseName == trimName || renderBaseOnly == 'true') {
            baseDisplay.css('background-color', baseColor);
            baseDisplay.show();
            baseDisplay.css('border', '1px solid #cccccc');
            trimDisplay.hide();
            selectedColors.html(baseName);
        } else {
            baseDisplay.css('background-color', baseColor);
            baseDisplay.css('border', '1px solid #cccccc');
            trimDisplay.css('background-color', trimColor);
            trimDisplay.css('border', '1px solid #cccccc');
            baseDisplay.show();
	  	trimDisplay.show();
            selectedColors.html(baseName + ' / ' + trimName);
        }
    } else {
        if (baseColor != "#") {
            baseDisplay.css('background-color', baseColor);
            baseDisplay.show();
        } else {
            baseDisplay.css('background-color', '#f8f8f8');
            baseDisplay.hide();
        }

        if (trimColor != "#") {
            trimDisplay.css('background-color', trimColor);
            trimDisplay.show();
        } else {
            trimDisplay.css('background-color', '#f8f8f8');
            trimDisplay.hide();
        }

        // this item doesn't have a product color 
        // still must show a visual cue that item has been choosen
        if (baseName == trimName || renderBaseOnly == 'true') {
            selectedColors.html(baseName);
        } else {
            selectedColors.html(baseName + ' / ' + trimName);
        }
    }

    // build the quantity/sizing chart each time color is changed...
    if (baseID != "-1" && trimID != "-1") {
        $.post("/ProductMobile/BuildSizingChart", {
            productid: productID,
            baseid: baseID,
            trimid: trimID,
            EditID: 0
        }, function(data) {
            $("#UpdateableContent").html(data);
        });
        $('#txtQty').html('');
        $('#SelectedQtyPrice').html('');
        $('#SelectedQtyTotal').html('');
    }

    // set 'add to cart' button if you can
    $('#hdItemColor').addClass('GoAhead');
    $('#ItemColor').html(baseName + ' / ' + trimName);
    AddToCartCriteriaMet();
}

function displaySizeLine(tableId) {
    $('#' + tableId).show();
    $('.sizingClosedLinks').hide();
}

function displaySizeLineOLD(lineIndex) {
    $('#sizeSelectionTbl tr').eq(lineIndex + 1).show();
    $('.sizingClosedLinks').eq(lineIndex - 1).hide();
    $('#sizeSelectionTbl td:hidden,#sizeSelectionTbl th:hidden').show();
    return false;
}

// EXTRAS
function AddExtras(productID, baseID, trimID) {
    if (nibInkOptions == null) {
        $.ajax({
            url: '/product/Extras',
            type: 'POST',
            data: {
                productid: productID,
                baseid: baseID,
                trimid: trimID
            },
            dataType: 'json',
            //timeout: 15000,
            success: function(data) {
                if (data.success == true) {
                    if (data.type == 'NibInk') {
                        var parsedData = $.parseJSON(data.message);
                        LoadNibInkColor(parsedData)
                    }
                    if (data.type == 'Adhesive') {
                        var parsedData = $.parseJSON(data.message);
                        LoadAdhesiveOptions(parsedData)
                    }
                } else {
                    // make sure the extras panel is hidden. 
                    $('#pnlBoxExtras').hide();
                }
            },
            error: function() {
                alert('error');
            }
        });
    }
}

function LoadNibInkColor(parsedData) {
    if (parsedData != null && parsedData.inknib.length > 0) {
        nibInkOptions = parsedData; // Set to the global object for use when the user is making selections

        var NibOptions = new Array();
        var ColorOptions = new Array();
        var EditNibValue = '';
        var EditInkColorValue = '';

        for (var i = 0; i < parsedData.inknib.length; i++) {
            var optionFound = false;

            // Look to see if the option has already been added to the nib option array
            for (var j = 0; j < NibOptions.length; j++) {
                if (!optionFound && NibOptions[j] == parsedData.inknib[i].nib) {
                    optionFound = true;
                }
            }

            // if the nib option was not found, add the option to the array for display
            if (!optionFound) {
                NibOptions[NibOptions.length] = parsedData.inknib[i].nib;
            } else {
                optionFound = false; // Reset the variable for the color check
            }

            // Look to see if the option has already been added to the color option array
            for (var j = 0; j < ColorOptions.length; j++) {
                if (!optionFound && ColorOptions[j] == parsedData.inknib[i].ink) {
                    optionFound = true;
                }
            }

            // if the nib option was not found, add the option to the array for display
            if (!optionFound) {
                ColorOptions[ColorOptions.length] = parsedData.inknib[i].ink;
            }

            if ($('#editItem').val() == 'true') {
                if (parsedData.inknib[i].id == $('#nibInkSelection').val()) {
                    EditInkColorValue = parsedData.inknib[i].ink;
                    EditNibValue = parsedData.inknib[i].nib;
                }
            }
        }

        $('#pnlExtras').html(''); // Remove anything previously displayed
        var extrasText = '';
        if (NibOptions.length > 1 || ColorOptions.length > 1) {
            $('#pnlBoxExtras').show();
        }

        // All color and nib options have been located, now display them if there's more than 1
        if (NibOptions.length > 1) {
            NibOptions.sort();
            $('#pnlExtras input').off('click', nibInkOptionChanged); // Unbind the handler from any previous radio buttons
            extrasText += '<div id="nibOptions">';
            extrasText += 'choose tip size';
            for (var i = 0; i < NibOptions.length; i++) {
                var radioBtn = '<span name="' + ColorOptions[i] + '"><input type="radio" name="nib" value="' + NibOptions[i] + '" onclick="nibInkOptionChanged()"';

                // Set up the selected option, the first option by default if the item is not being edited
                if (($('#editItem').val() == 'true' && NibOptions[i] == EditNibValue) || ($('#editItem').val() != 'true' && i == 0)) {
                    radioBtn += ' checked';
                }

                radioBtn += ' />' + NibOptions[i] + '</span>';
                extrasText += radioBtn;
            }
            extrasText += '</div>';
            $('#pnlExtras input').on('click', nibInkOptionChanged); // Bind the handler to the new radio buttons
        }

        if (ColorOptions.length > 1) {
            ColorOptions.sort();
            $('#pnlExtras input').off('click', nibInkOptionChanged); // Unbind the handler from any previous radio buttons
            extrasText += '<div id="inkColorOptions">';
            extrasText += 'choose writing ink color';
            for (var i = 0; i < ColorOptions.length; i++) {
                var radioBtn = '<span name="' + ColorOptions[i] + '"><input type="radio" name="ink" value="' + ColorOptions[i] + '" onclick="nibInkOptionChanged()"';

                // Set up the selected option, the first option by default if the item is not being edited
                if (($('#editItem').val() == 'true' && ColorOptions[i] == EditInkColorValue) || ($('#editItem').val() != 'true' && i == 0)) {
                    radioBtn += ' checked';
                }

                radioBtn += ' />' + ColorOptions[i] + '</span>';
                extrasText += radioBtn;
            }
            extrasText += '</div>';
            $('#pnlExtras input').on('click', nibInkOptionChanged); // Bind the handler to the new radio buttons
        }

        $('#pnlExtras').append(extrasText);

        if (nibInkOptions.inknib.length > 0 && (NibOptions.length > 1 || ColorOptions.length > 1)) {
            // If there is a nib or color selection to be made, set the default selections into the hidden input
            // Edit mode implications?
            $('#selectedExtraID').val(nibInkOptions.inknib[0].id);

            // Do the initial pass on the ink colors to make sure only the available ones are displayed
            toggleAvailableInkColors();
        }
    } else {
        $('#pnlBoxExtras').hide(); // hide the extras panel
        $('#selectedExtraID').val(''); // clear out the hidden field
    }
}

function LoadAdhesiveOptions(parsedData) {
    if (parsedData != null && parsedData.adhesive.length > 0) {
        adhSidesOptions = parsedData; // Set to the global object for use when the user is making selections

        var AdhesiveOptions = new Array();
        var AdhSideOptions = new Array();
        var EditAdhesiveValue = '';
        var EditAdhSideValue = '';

        for (var i = 0; i < parsedData.adhesive.length; i++) {
            var optionFound = false;

            // Look to see if the option has already been added to the adhesive option array
            for (var j = 0; j < AdhesiveOptions.length; j++) {
                if (!optionFound && AdhesiveOptions[j] == parsedData.adhesive[i].adh) {
                    optionFound = true;
                }
            }

            // if the adhesive option was not found, add the option to the array for display
            if (!optionFound) {
                AdhesiveOptions[AdhesiveOptions.length] = parsedData.adhesive[i].adh;
            } else {
                optionFound = false; // Reset the variable for the color check
            }

            // Look to see if the option has already been added to the side option array
            for (var j = 0; j < AdhSideOptions.length; j++) {
                if (!optionFound && AdhSideOptions[j] == parsedData.adhesive[i].side) {
                    optionFound = true;
                }
            }

            // if the side option was not found, add the option to the array for display
            if (!optionFound) {
                AdhSideOptions[AdhSideOptions.length] = parsedData.adhesive[i].side;
            }

            if ($('#editItem').val() == 'true') {
                if (parsedData.adhesive[i].id == $('#adhesiveSelection').val()) {
                    EditAdhSideValue = parsedData.adhesive[i].side;
                    EditAdhesiveValue = parsedData.adhesive[i].adh;
                }
            }
        }

        $('#pnlExtras').html(''); // Remove anything previously displayed
        var extrasText = '';
        if (AdhesiveOptions.length > 1 || AdhSideOptions.length > 1) {
            $('#pnlBoxExtras').show();
        }

        // All adhesive options have been located, now display them if there's more than 1
        if (AdhesiveOptions.length > 1) {
            AdhesiveOptions.sort();
            extrasText += '<div id="adhesiveOptions">';
            extrasText += 'choose adhesive type';
            for (var i = 0; i < AdhesiveOptions.length; i++) {
                var radioBtn = '<span name="' + AdhSideOptions[i] + '"><input type="radio" name="adhesive" value="' + AdhesiveOptions[i] + '" onclick="adhesiveOptionChanged()"';

                // Set up the selected option, the first option by default if the item is not being edited
                if (($('#editItem').val() == 'true' && AdhesiveOptions[i] == EditAdhesiveValue) || ($('#editItem').val() != 'true' && i == 0)) {
                    radioBtn += ' checked';
                }

                radioBtn += ' />' + AdhesiveOptions[i] + '</span>';
                extrasText += radioBtn;
            }
            extrasText += '</div>';
        }

        if (AdhSideOptions.length > 1) {
            AdhSideOptions.sort();
            extrasText += '<div id="adhSideOptions">';
            extrasText += 'choose adhesive side';
            for (var i = 0; i < AdhSideOptions.length; i++) {
                var radioBtn = '<span name="' + AdhSideOptions[i] + '"><input type="radio" name="adhSide" value="' + AdhSideOptions[i] + '" onclick="adhesiveOptionChanged()"';

                // Set up the selected option, the first option by default if the item is not being edited
                if (($('#editItem').val() == 'true' && AdhSideOptions[i] == EditAdhSideValue) || ($('#editItem').val() != 'true' && i == 0)) {
                    radioBtn += ' checked';
                }

                radioBtn += ' />' + AdhSideOptions[i] + '</span>';
                extrasText += radioBtn;
            }
            extrasText += '</div>';
        }

        $('#pnlExtras').append(extrasText);

        if (adhSidesOptions.adhesive.length > 0 && (AdhesiveOptions.length > 1 || AdhSideOptions.length > 1)) {
            // If there is a side or type selection to be made, set the default selections into the hidden input
            // Edit mode implications?
            $('#selectedExtraID').val(adhSidesOptions.adhesive[0].id);

            // Do the initial pass on the sides to make sure only the available ones are displayed
            toggleAvailableAdhesiveSides();
        }
    } else {
        $('#pnlBoxExtras').hide(); // hide the extras panel
        $('#selectedExtraID').val(''); // clear out the hidden field
    }
}

function nibInkOptionChanged() {
    toggleAvailableInkColors();

    // Find the selected nib and ink color in the master list and set the id to the hidden input
    var selectedInk = $('#pnlExtras #inkColorOptions input:checked').val();
    var selectedNib = $('#pnlExtras #nibOptions input:checked').val();

    for (var i = 0; i < nibInkOptions.inknib.length; i++) {
        if ((selectedInk == nibInkOptions.inknib[i].ink && selectedNib == nibInkOptions.inknib[i].nib) ||
            (typeof selectedInk == 'undefined' && selectedNib == nibInkOptions.inknib[i].nib) ||
            (selectedInk == nibInkOptions.inknib[i].ink && typeof selectedNib == 'undefined')) {
            $('#selectedExtraID').val(nibInkOptions.inknib[i].id);
            return;
        }
    }
}

function adhesiveOptionChanged() {
    toggleAvailableAdhesiveSides();

    // Find the selected nib and ink color in the master list and set the id to the hidden input
    var selectedAdhesive = $('#adhesiveOptions input:checked').val();
    var selectedAdhSide = $('#adhSideOptions input:checked').val();

    for (var i = 0; i < adhSidesOptions.adhesive.length; i++) {
        if ((selectedAdhSide == adhSidesOptions.adhesive[i].side && selectedAdhesive == adhSidesOptions.adhesive[i].adh) ||
            (typeof selectedAdhSide == 'undefined' && selectedAdhesive == adhSidesOptions.adhesive[i].adh) ||
            (selectedAdhSide == adhSidesOptions.adhesive[i].side && typeof selectedAdhesive == 'undefined')) {
            $('#selectedExtraID').val(adhSidesOptions.adhesive[i].id);
            return;
        }
    }
}

function toggleAvailableAdhesiveSides() {
    // Need to hide adhesive sides that are not available for the selected adhesive type
    var selectedAdh = $('#adhesiveOptions input:checked').val();

    // Don't bother unless there are adhesive types and sides set
    if (typeof selectedAdh != 'undefined' && adhSidesOptions.adhesive.length > 0) {
        var adhSideOptions = $('#adhSideOptions span');
        if (adhSideOptions.length > 0) {
            var selectedAdhesiveSides = new Array();

            // Populate the array with all of the possible sides for this adhesive type
            for (var i = 0; i < adhSidesOptions.adhesive.length; i++) {
                if (selectedAdh == adhSidesOptions.adhesive[i].adh) {
                    selectedAdhesiveSides[selectedAdhesiveSides.length] = adhSidesOptions.adhesive[i];
                }
            }

            // Toggle the side options
            for (var i = 0; i < selectedAdhesiveSides.length; i++) {
                var sideFound = false;

                for (var j = 0; j < adhSideOptions.length; j++) {
                    if (!sideFound && $(selectedAdhesiveSides[i]).attr('name') == adhSideOptions[j].adh) {
                        colorFound = true;
                    }
                }

                if (colorFound) {
                    $(adhSideOptions[i]).show();
                } else {
                    $(adhSideOptions[i]).hide();

                    // If the option being hidden is checked, move the option to the first visible option
                    if ($(adhSideOptions[i]).children('input').is(':checked')) $('#adhSideOptions span:visible input').eq(0).attr('checked', 'checked');
                }
            }
        }
    }
}

function toggleAvailableInkColors() {
    // Need to hide ink colors that are not available for the selected nib size
    var selectedNib = $('#nibOptions input:checked').val();

    // Don't bother unless there are nib options and there are ink options set
    if (typeof selectedNib != 'undefined' && nibInkOptions.inknib.length > 0) {
        var inkOptions = $('#inkColorOptions span');
        if (inkOptions.length > 0) {
            var nibInkColors = new Array();

            // Populate the array with all of the possible ink colors for this nib
            for (var i = 0; i < nibInkOptions.inknib.length; i++) {
                if (selectedNib == nibInkOptions.inknib[i].nib) {
                    nibInkColors[nibInkColors.length] = nibInkOptions.inknib[i];
                }
            }

            // Toggle the ink colors
            for (var i = 0; i < inkOptions.length; i++) {
                var colorFound = false;

                for (var j = 0; j < nibInkColors.length; j++) {
                    if (!colorFound && $(inkOptions[i]).attr('name') == nibInkColors[j].ink) {
                        colorFound = true;
                    }
                }

                if (colorFound) {
                    $(inkOptions[i]).show();
                } else {
                    $(inkOptions[i]).hide();

                    // If the option being hidden is checked, move the option to the first visible ink option
                    if ($(inkOptions[i]).children('input').is(':checked')) $('#inkColorOptions span:visible input').eq(0).attr('checked', 'checked');
                }
            }
        }
    }
}

// Check if it's safe to add to the cart
function AddToCartCriteriaMet() {
    // make the Add To Cart button clickable
    if ($('#hdItemColor').hasClass('GoAhead') && $('#hdQuantity').hasClass('GoAhead') && $('#hdImprint').hasClass('GoAhead')) {
        $('#cartBtn').addClass('addToCartBtn');
        $('#cartBtn').removeClass('bkgdMdGray textDkGray');
        $('#cartBtn').addClass('bkgdRed textWhite');
        $('#cartBtn').removeClass('notReadyForCartBtn');

        
    } else {
        $('#cartBtn').removeClass('bkgdRed textWhite');
        $('#cartBtn').addClass('bkgdMdGray textDkGray');
        $('#cartBtn').removeClass('addToCartBtn');
        $('#cartBtn').addClass('notReadyForCartBtn');

        
    }
}

String.prototype.endsWith = function(str) {
    return (this.match(str + "$") == str)
}

//Begin Mobile/js/Sop.js function move
// apparel - check for minimum quantity
function checkApparelQty() {
    qtyBox = $('.sizingTotalQtyNbr').html();
    if ((!IsNumeric(qtyBox)) || qtyBox == '') {
        alert("Please specify how many of this item you would like to order by entering a numeric value in the size boxes you would like."); // Formerly in litNoQuantityWarning
        return false;
    }
    else if (parseInt(qtyBox) < lowestQty) {
        alert("To order this item, you need to order a minimum quantity of " + lowestQty + ".\n Please ensure that you order at least this many, or choose a different item.");  // Formerly in litNoQuantityWarning
        return false;
    }
    else { return true; }
}

// apparel - size quantities into string for hidden field #SizeSelections
function setQuantity() {
    if (checkApparelQty()) {
        var Qty = $('.sizingTotalQtyNbr').html();
        var SteppedQty = glide.EnforceSteppingQty(Qty, steppingQty);
        if (Qty != SteppedQty) {
            // Enforce the stepping qty
            alert('The product you are ordering must be ordered in cases of ' + steppingQty + '.\n\nPlease adjust the quantities on your sizes appropriately.\n(Hint: The closest valid total quantity is ' + SteppedQty + '.)');
        } else {
            // Load up sizes here
            var storedSizes = '';	// Holds the hashed string of sizes that gets put in the hidden input for parsing server side on postback

            $('.sizeSelectionTbl').each(function(){
                var prodid = $(this).find('.sizeSelectionHdr').attr('data-prodid');
                var qtyVal = '';
                $(this).find('tr.sizeSelectionLine').each(function (i) {
                    var prodattrid = $(this).find('input:hidden').val();
                    qtyVal = $(this).find('.qty').val();
                    var quantity = qtyVal.length > 0 ? parseInt(qtyVal) : 0;
                    if (quantity > 0) {
                        storedSizes += prodid + '-' + prodattrid + '-' + quantity + '|';
                    }
                });
            });

            if (storedSizes.endsWith("|")) {
                storedSizes = storedSizes.substring(0, storedSizes.length - 1);
            }

            $('#SizeSelections').val(storedSizes);
        }
    }
    return false;
}

// apparel - size quantities into string for hidden field #SizeSelections
// redoing method specifically for updating the item when editing it after having been added to cart
function setQuantityWhenUpdating() {
    if (checkApparelQty()) {
        var Qty = $('.sizingTotalQtyNbr').html();
        var SteppedQty = glide.EnforceSteppingQty(Qty, steppingQty);
        if (Qty != SteppedQty) {
            // Enforce the stepping qty
            alert('The product you are ordering must be ordered in cases of ' + steppingQty + '.\n\nPlease adjust the quantities on your sizes appropriately.\n(Hint: The closest valid total quantity is ' + SteppedQty + '.)');
			
			return false;
		} else {
            // Load up sizes here
            var storedSizes = '';	// Holds the hashed string of sizes that gets put in the hidden input for parsing server side on postback

            $('.sizeSelectionTbl').each(function(){
                var prodid = $(this).find('.sizeSelectionHdr').attr('data-prodid');
                var qtyVal = '';
                $(this).find('tr.sizeSelectionLine').each(function (i) {
                    var prodattrid = $(this).find('input:hidden').val();
                    qtyVal = $(this).find('.qty').val();
                    var quantity = qtyVal.length > 0 ? parseInt(qtyVal) : 0;
                    if (quantity > 0) {
                        storedSizes += prodid + '-' + prodattrid + '-' + quantity + '|';
                    }
                });
            });

            if (storedSizes.endsWith("|")) {
                storedSizes = storedSizes.substring(0, storedSizes.length - 1);
            }

            $('#SizeSelections').val(storedSizes);
			return true;
        }
    }else{
		return false;
	}
}

// omniture metrics
function metricsLogWishlistClick(buttonID) {
	var s=s_gi('4imprintmobile'); 
	s.linkTrackVars='eVar27,events,prop14';
	s.linkTrackEvents='event24';
	s.eVar27=buttonID;
	s.events = 'event24'; 
	s.prop14= "Add to Wishlist";
	s.tl(this, 'o', 'Button Click');  
}
//End Mobile/js/Sop.js function move.